import React, { FC, useState } from 'react';

import { useIsAdmin } from '@app/hooks/use-is-admin';
import { useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';

import { useColumns } from './columns';
import EditVar from './edit';
import Error404 from '../../errors/404';

const RoutesTable: FC = () => {
  const isAdmin = useIsAdmin();
  const api = useApi();
  const [fetchData] = useFetchData<EntityBase>({ method: api.acb.getRoutes });

  const [editOpen, setEditOpen] = useState(false);
  const [operatedVar, setOperatedVar] = useState<EntityBase>();

  const columns = useColumns({
    onEdit: (route: EntityBase) => {
      setOperatedVar(route);
      setEditOpen(true);
    }
  });

  const onClose = () => {
    setEditOpen(false);
  };


  if (!isAdmin) {
    return <Error404/>;
  }

  return (
    <>
      <QueryTable
        title="Маршруты"
        columns={columns}
        onCreateClick={() => {
          setOperatedVar(undefined);
          setEditOpen(true);
        }}
        fetchData={fetchData}
        canDownload
      >
        <EditVar open={editOpen} setOpen={onClose} route={operatedVar} />
      </QueryTable>
    </>
  );
};

export default RoutesTable;
